// extracted by mini-css-extract-plugin
module.exports = {"image-thumbnail-avator":"MediaThumbnail_image-thumbnail-avator__2TD25"};